import { Bank } from '@/interfaces/banks';
import request from '@/umi-request';
import { AxiosPromise } from 'axios';

export async function getBanks() {
  return request({
    url: 'banks/',
    method: 'GET',
  }) as AxiosPromise<Bank[]>;
}
